import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../environments/environment';

// Ajoutez cette interface avec les autres
export interface ProgressIndicator {
  id: number;
  phaseName: 'GROS_OEUVRE' | 'SECOND_OEUVRE' | 'FINITION';
  progressPercentage: number;
  lastUpdated: string;
}

export interface BudgetResponse {
  id: number;
  plannedBudget: number;
  consumedBudget: number;
  remainingBudget: number;
}
export interface CreateTaskRequest {
  title: string;
  description: string;
  priority: 'LOW' | 'MEDIUM' | 'HIGH';
  startDate: string; // Format: MM-DD-YYYY
  endDate: string;   // Format: MM-DD-YYYY
  realEstatePropertyId: number;
  executorIds: number[];
  pictures: string[]; // Tableau de base64 strings
}

export interface UpdateTaskRequest {
  status: string; // Rendre obligatoire au lieu de optionnel
  title?: string;
  description?: string;
  priority?: string;
  startDate?: string;
  endDate?: string;
  realEstatePropertyId?: number;
  executorIds?: number[];
  pictures?: string[];
}
export interface ProgressAlbum {
  id: number;
  phaseName: string;
  description: string;
  lastUpdated: string | number[];
  pictures: string[];
  entrance: boolean;
  realEstateProperty: {
    id: number;
    name: string;
    address: string;
    plan: string;
  };
}

export interface Task {
  id: number;
  title: string;
  description: string;
  priority: 'LOW' | 'MEDIUM' | 'HIGH';
  status: 'TODO' | 'IN_PROGRESS' | 'BLOCKED' | 'DONE';
  startDate: number[];
  endDate: number[];
  pictures: string[];
  realEstateProperty: {
    id: number;
    name: string;
    number: string;
    address: string;
    price: number;
    numberOfRooms: number;
    area: number;
    latitude: string;
    longitude: string;
    available: boolean;
    reservationFee: number;
    discount: number;
    feesFile: number;
    description: string;
    plan: string;
    legalStatus: string;
    numberOfLots: number;
    level: number;
    promoter: {
      id: number;
      nom: string;
      prenom: string;
      email: string;
      password: string;
      adress: string;
      technicalSheet: string | null;
      profil: string;
      activated: boolean;
      notifiable: boolean;
      telephone: string;
      subscriptions: Array<{
        id: number;
        subscriptionPlan: {
          id: number;
          name: string;
          totalCost: number;
          installmentCount: number;
        };
        startDate: number[];
        endDate: number[];
        active: boolean;
        paidAmount: number;
        installmentCount: number;
        dateInvoice: string | null;
        status: string;
        renewed: boolean;
      }>;
      company: {
        id: number;
        name: string | null;
        logo: string;
        primaryColor: string | null;
        secondaryColor: string | null;
      };
      createdAt: number[];
      funds: number;
      note: number;
      photo: string | null;
      idCard: string | null;
      accountNonExpired: boolean;
      credentialsNonExpired: boolean;
      accountNonLocked: boolean;
      hibernateLazyInitializer: any;
      username: string;
      authorities: Array<{
        authority: string;
      }>;
      enabled: boolean;
    };
    recipient: any;
    notary: any;
    agency: any;
    bank: any;
    parentProperty: any;
    timestamp: number;
    pictures: string[];
    propertyType: {
      id: number;
      typeName: string;
      parent: boolean;
      hibernateLazyInitializer: any;
    };
    constructionPhaseIndicators: Array<{
      id: number;
      phaseName: string;
      progressPercentage: number;
      lastUpdated: string;
    }>;
    hasHall: boolean;
    hasParking: boolean;
    hasElevator: boolean;
    hasSwimmingPool: boolean;
    hasGym: boolean;
    hasPlayground: boolean;
    hasSecurityService: boolean;
    hasGarden: boolean;
    hasSharedTerrace: boolean;
    hasBicycleStorage: boolean;
    hasLaundryRoom: boolean;
    hasStorageRooms: boolean;
    hasWasteDisposalArea: boolean;
    status: string;
    constructionStatus: string;
    lotFeesPaid: boolean;
    lotFee: {
      id: number;
      name: string;
      fee: number;
      hibernateLazyInitializer: any;
    };
    coOwner: boolean;
    budget: number;
    allocateDate: string | null;
    rental: boolean;
    commentcount: number;
    rentalDate: string | null;
    soldAt: string | null;
    workers: any[];
    startDate: number[];
    endDate: number[];
    hibernateLazyInitializer: any;
    mezzanine: boolean;
  };
  executors: Array<{
    id: number;
    nom: string;
    prenom: string;
    email: string;
    password: string;
    adress: string;
    technicalSheet: string | null;
    profil: string;
    activated: boolean;
    notifiable: boolean;
    telephone: string;
    subscriptions: Array<{
      id: number;
      subscriptionPlan: {
        id: number;
        name: string;
        totalCost: number;
        installmentCount: number;
      };
      startDate: number[];
      endDate: number[];
      active: boolean;
      paidAmount: number;
      installmentCount: number;
      dateInvoice: string | null;
      status: string;
      renewed: boolean;
    }>;
    company: any;
    createdAt: number[];
    funds: number;
    note: number;
    photo: string;
    idCard: string | null;
    accountNonExpired: boolean;
    credentialsNonExpired: boolean;
    accountNonLocked: boolean;
    username: string;
    authorities: Array<{
      authority: string;
    }>;
    enabled: boolean;
  }>;
}

export interface TasksResponse {
  content: Task[];
  pageable: {
    pageNumber: number;
    pageSize: number;
    sort: {
      unsorted: boolean;
      sorted: boolean;
      empty: boolean;
    };
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  totalElements: number;
  totalPages: number;
  last: boolean;
  numberOfElements: number;
  size: number;
  number: number;
  sort: {
    unsorted: boolean;
    sorted: boolean;
    empty: boolean;
  };
  first: boolean;
  empty: boolean;
}

export interface Expense {
  id: number;
  description: string;
  date: number[];
  amount: number;
  budget: {
    id: number;
    plannedBudget: number;
    consumedBudget: number;
    remainingBudget: number;
    property: any;
  };
  evidence: string

}

export interface ExpensesResponse {
  content: Expense[];
  pageable: {
    pageNumber: number;
    pageSize: number;
    sort: {
      unsorted: boolean;
      sorted: boolean;
      empty: boolean;
    };
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  totalElements: number;
  totalPages: number;
  last: boolean;
  numberOfElements: number;
  size: number;
  number: number;
  sort: {
    unsorted: boolean;
    sorted: boolean;
    empty: boolean;
  };
  first: boolean;
  empty: boolean;
}

// Ajoutez cette interface dans votre service (expense.service.ts)
export interface CreateExpenseRequest {
  description?: string;
  date: string; // Format: MM-DD-YYYY
  amount?: number;
  budgetId?: number;
  evidence?: File;
}

export interface ExpenseResponse {
  id: number;
  description?: string;
  date: string;
  amount?: number;
  budgetId?: number;
  evidencePath?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAlbumRequest {
  realEstatePropertyId: number;
  name: string;
  description: string;
  pictures: string[];
}

export interface UpdateAlbumRequest {
  name?: string;
  description?: string;
  pictures?: string[];
}
export interface IndicatorUpdateResponse {
  id: number;
  phaseName: string;
  progressPercentage: number;
  lastUpdated: string;
}

export interface DocumentType {
  id: number;
  label: string;
  code: string;
  hasStartDate: boolean;
  hasEndDate: boolean;
  type: string;
}

export interface DocumentTypesResponse {
  content: DocumentType[];
}

export interface Document {
  id: number;
  title: string;
  file: string;
  description: string;
  type: DocumentType | null;
  startDate: number[];
  endDate: number[];
}

export interface DocumentsResponse {
  content: Document[];
  pageable: {
    pageNumber: number;
    pageSize: number;
    sort: {
      unsorted: boolean;
      sorted: boolean;
      empty: boolean;
    };
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  totalElements: number;
  totalPages: number;
  last: boolean;
  numberOfElements: number;
  size: number;
  number: number;
  sort: {
    unsorted: boolean;
    sorted: boolean;
    empty: boolean;
  };
  first: boolean;
  empty: boolean;
}

export interface CreateDocumentRequest {
  title: string;
  file: string;
  description: string;
  realEstatePropertyId: number;
  typeId: number;
  startDate: string; // format dd-MM-yyyy
  endDate: string; // format dd-MM-yyyy
}

// Nouvelles interfaces pour les signalements
export interface Signalement {
  id: number;
  title: string;
  description: string;
  createdAt: number[];
  updatedAt: number[] | null;
  status: string | null;
  authorId: number | null;
  authorName: string | null;
  propertyName: string;
  pictures: string[];
}

export interface AlertIAReport {
  id: number;
  incidentId: number;
  propertyId: number;
  propertyName: string;
  incidentType: string;
  severity: string;
  explanation: { en: string; fr: string };
  recommendation: { en: string; fr: string };
  createdAt: number[];
}

export interface SignalementResponse {
  content: Signalement[];
  pageable: {
    pageNumber: number;
    pageSize: number;
    sort: {
      unsorted: boolean;
      sorted: boolean;
      empty: boolean;
    };
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  totalElements: number;
  totalPages: number;
  last: boolean;
  numberOfElements: number;
  size: number;
  number: number;
  sort: {
    unsorted: boolean;
    sorted: boolean;
    empty: boolean;
  };
  first: boolean;
  empty: boolean;
}

export interface CreateSignalementRequest {
  title: string;
  description: string;
  propertyId: number;
  pictures: string[];
}

@Injectable({
  providedIn: 'root'
})
export class ProjectBudgetService {
  private endpoints = environment.endpoints;
  private apiUrl = environment.apiUrl; // Kept for endpoints not in pointage API

  constructor(private http: HttpClient) { }

  getDetailsAlertFromIA(incidentId: number): Observable<AlertIAReport> {
    return this.http.get<AlertIAReport>(
      `${this.apiUrl}/incident-rapports/by-incident/${incidentId}`,
      { headers: this.getAuthHeaders() }
    );
  }

  // Méthode privée pour obtenir les headers d'authentification
  private getAuthHeaders(forFormData: boolean = false): HttpHeaders {
    const token = localStorage.getItem('token') ||
      sessionStorage.getItem('token') ||
      localStorage.getItem('authToken') ||
      sessionStorage.getItem('authToken') ||
      localStorage.getItem('accessToken') ||
      sessionStorage.getItem('accessToken') ||
      localStorage.getItem('jwt') ||
      sessionStorage.getItem('jwt');

    console.log('Token récupéré pour headers:', token ? token.substring(0, 20) + '...' : 'null');

    if (!token) {
      console.warn('Aucun token d\'authentification trouvé');
      return new HttpHeaders();
    }

    if (forFormData) {
      return new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
    }

    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    });
  }

  // Méthode pour gérer les erreurs HTTP
  private handleError(error: HttpErrorResponse) {
    console.error('Erreur HTTP détaillée:', error);

    let errorMessage = 'Une erreur est survenue';

    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Code d'erreur: ${error.status}\nMessage: ${error.message}`;

      if (error.status === 403) {
        errorMessage = "Accès refusé. Vérifiez vos autorisations.";
      } else if (error.status === 401) {
        errorMessage = "Session expirée. Veuillez vous reconnecter.";
      } else if (error.status === 400) {
        errorMessage = "Données invalides. Vérifiez les informations saisies.";
      } else if (error.status === 404) {
        errorMessage = "Ressource introuvable.";
      }
    }

    return throwError(errorMessage);
  }
  createTask(taskData: CreateTaskRequest): Observable<any> {
    const headers = this.getAuthHeaders(true);

    const formData = new FormData();

    formData.append('title', taskData.title);
    formData.append('description', taskData.description);
    formData.append('priority', taskData.priority);
    formData.append('startDate', taskData.startDate);
    formData.append('endDate', taskData.endDate);
    formData.append('realEstatePropertyId', taskData.realEstatePropertyId.toString());

    taskData.executorIds.forEach((executorId) => {
      formData.append('executorIds', executorId.toString());
    });

    if (taskData.pictures && taskData.pictures.length > 0) {
      taskData.pictures.forEach((pictureBase64: string, index: number) => {
        try {
          const blob = this.base64ToBlob(pictureBase64);
          const fileName = `task-image-${index + 1}.png`;
          formData.append('pictures', blob, fileName);
        } catch (error) {
          console.error(`Erreur conversion image ${index + 1}:`, error);
        }
      });
    }

    console.log('📤 Création de tâche - Données brutes:', taskData);
    console.log('📤 FormData envoyé:');
    for (const [key, value] of (formData as any).entries()) {
      console.log(`  ${key}: ${value instanceof File ? `[File: ${value.name}]` : value}`);
    }
    console.log('📤 Création de tâche:', {
      title: taskData.title,
      propertyId: taskData.realEstatePropertyId,
      executorCount: taskData.executorIds.length,
      executorIds: taskData.executorIds,
      pictureCount: taskData.pictures?.length || 0
    });

    return this.http.post<any>(
      `${this.apiUrl}/tasks`,
      formData,
      { headers }
    ).pipe(
      catchError((error) => {
        console.error('❌ Erreur création tâche:', error);
        console.error('❌ Détails erreur:', {
          status: error.status,
          message: error.error?.message,
          error: error.error
        });
        return throwError(() => ({
          status: error.status,
          message: error.error?.message || error.message || 'Erreur lors de la création de la tâche',
          error: error
        }));
      })
    );
  }
  updateTaskStatus(id: number, status: string): Observable<any> {
    const headers = this.getAuthHeaders(true);

    const formData = new FormData();
    formData.append('status', status);

    console.log('📤 Mise à jour statut:', { taskId: id, newStatus: status });

    return this.http.put<any>(
      `${this.apiUrl}/tasks/${id}/status`,
      formData,
      { headers }
    ).pipe(
      catchError((error) => {
        console.error('❌ Erreur mise à jour statut:', error);

        // Retourner un objet d'erreur structuré
        return throwError(() => ({
          status: error.status,
          message: error.error?.message || error.message || 'Erreur lors de la mise à jour du statut',
          error: error
        }));
      })
    );
  }

  // Dans votre service
  updateTask(id: number, taskData: UpdateTaskRequest): Observable<any> {
    const headers = this.getAuthHeaders(true);

    const formData = new FormData();

    // ✅ AMÉLIORATION: Toujours inclure le statut (obligatoire selon l'interface)
    formData.append('status', taskData.status);

    // Ajouter les autres champs s'ils sont présents
    if (taskData.title !== undefined && taskData.title !== null) {
      formData.append('title', taskData.title);
    }
    if (taskData.description !== undefined && taskData.description !== null) {
      formData.append('description', taskData.description);
    }
    if (taskData.priority !== undefined && taskData.priority !== null) {
      formData.append('priority', taskData.priority);
    }
    if (taskData.startDate !== undefined && taskData.startDate !== null) {
      formData.append('startDate', taskData.startDate);
    }
    if (taskData.endDate !== undefined && taskData.endDate !== null) {
      formData.append('endDate', taskData.endDate);
    }
    if (taskData.realEstatePropertyId !== undefined && taskData.realEstatePropertyId !== null) {
      formData.append('realEstatePropertyId', taskData.realEstatePropertyId.toString());
    }

    // Ajouter les executors
    if (taskData.executorIds && taskData.executorIds.length > 0) {
      taskData.executorIds.forEach((executorId) => {
        formData.append('executorIds', executorId.toString());
      });
    }

    // Ajouter les pictures
    if (taskData.pictures && taskData.pictures.length > 0) {
      taskData.pictures.forEach((pictureBase64: string, index: number) => {
        try {
          const blob = this.base64ToBlob(pictureBase64);
          const fileName = `task-image-${index + 1}.png`;
          formData.append('pictures', blob, fileName);
        } catch (error) {
          console.error(`Erreur conversion image ${index + 1}:`, error);
        }
      });
    }

    console.log('📤 Mise à jour tâche:', {
      taskId: id,
      status: taskData.status,
      hasTitle: !!taskData.title,
      hasDescription: !!taskData.description,
      executorCount: taskData.executorIds?.length || 0,
      pictureCount: taskData.pictures?.length || 0
    });

    return this.http.put<any>(
      `${this.apiUrl}/tasks/${id}`,
      formData,
      { headers }
    ).pipe(
      catchError((error) => {
        console.error('❌ Erreur mise à jour tâche:', error);
        return throwError(() => ({
          status: error.status,
          message: error.error?.message || error.message || 'Erreur lors de la mise à jour de la tâche',
          error: error
        }));
      })
    );
  }
  // Méthode utilitaire pour convertir base64 en Blob
  private base64ToBlob(base64: string): Blob {
    try {
      // Extraire le type MIME et les données base64
      const parts = base64.split(';base64,');
      if (parts.length < 2) {
        throw new Error('Format base64 invalide');
      }

      const mimeType = parts[0].split(':')[1];
      const byteString = atob(parts[1]);

      // Convertir en ArrayBuffer
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const uint8Array = new Uint8Array(arrayBuffer);

      for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i);
      }

      return new Blob([arrayBuffer], { type: mimeType });
    } catch (error) {
      console.error('Erreur lors de la conversion base64 en Blob:', error);
      throw new Error('Impossible de convertir l\'image');
    }
  }

  // === MÉTHODES POUR LES ALBUMS AVEC FORMDATA ===

  saveAlbum(album: any): Observable<any> {
    const headers = this.getAuthHeaders(true);

    // Créer un FormData pour l'envoi multipart
    const formData = new FormData();

    // Ajouter les champs texte
    formData.append('realEstatePropertyId', album.realEstatePropertyId.toString());
    formData.append('name', album.name);
    formData.append('description', album.description);

    // Ajouter les images (convertir les base64 en fichiers Blob)
    if (album.pictures && album.pictures.length > 0) {
      album.pictures.forEach((pictureBase64: string, index: number) => {
        try {
          const blob = this.base64ToBlob(pictureBase64);
          const fileName = `image-${index + 1}.png`;
          formData.append('pictures', blob, fileName);
        } catch (error) {
          console.error(`Erreur avec l'image ${index + 1}:`, error);
        }
      });
    }

    console.log('Envoi FormData avec:', {
      realEstatePropertyId: album.realEstatePropertyId,
      name: album.name,
      description: album.description,
      pictureCount: album.pictures ? album.pictures.length : 0
    });

    return this.http.post<any>(
      `${this.apiUrl}/progress-album/save`,
      formData,
      { headers }
    ).pipe(
      catchError((error) => {
        console.error('Erreur détaillée lors de la création d\'album:', error);
        return this.handleError(error);
      })
    );
  }

  updateAlbum(id: number, album: any): Observable<any> {
    const headers = this.getAuthHeaders(true);

    const formData = new FormData();

    if (album.name) formData.append('name', album.name);
    if (album.description) formData.append('description', album.description);

    // Ajouter les nouvelles images si présentes
    if (album.pictures && album.pictures.length > 0) {
      album.pictures.forEach((pictureBase64: string, index: number) => {
        try {
          const blob = this.base64ToBlob(pictureBase64);
          const fileName = `image-${index + 1}.png`;
          formData.append('pictures', blob, fileName);
        } catch (error) {
          console.error(`Erreur avec l'image ${index + 1}:`, error);
        }
      });
    }

    return this.http.put<any>(
      `${this.apiUrl}/progress-album/update/${id}`,
      formData,
      { headers }
    ).pipe(catchError(this.handleError));
  }


  // Ajoutez cette méthode dans la classe ProjectBudgetService
  /**
   * Récupère les indicateurs de progression d'un projet
   */
  getIndicatorsByProperty(propertyId: number): Observable<ProgressIndicator[]> {
    console.log(`📊 Récupération des indicateurs du projet ${propertyId}`);

    return this.http.get<ProgressIndicator[]>(
      `${this.apiUrl}/indicators/property/${propertyId}`,
      { headers: this.getAuthHeaders() }
    );
  }

  /**
   * Formate le nom de phase pour l'affichage
   */
  formatPhaseName(phaseName: string): string {
    const phaseMap: Record<string, string> = {
      'GROS_OEUVRE': 'Gros œuvre',
      'SECOND_OEUVRE': 'Second œuvre',
      'FINITION': 'Finition'
    };
    return phaseMap[phaseName] || phaseName;
  }

  /**
   * Formate la date ISO en format dd/MM/yyyy
   */
  formatIndicatorDate(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
  // === MÉTHODES EXISTANTES ===

  GetProjectBudget(propertyId: number): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get<any>(`${this.apiUrl}/budgets/property/${propertyId}`, { headers })
      .pipe(catchError(this.handleError));
  }

  getAlbum(propertyId: number): Observable<any[]> {
    const headers = this.getAuthHeaders();
    return this.http.get<any[]>(`${this.apiUrl}/progress-album/by-property/${propertyId}`, { headers })
      .pipe(catchError(this.handleError));
  }

  // 4. ✅ CORRECTION: getTasks - Ajout de logs et meilleure gestion d'erreurs
  getTasks(propertyId: number, page: number = 0, size: number = 10): Observable<TasksResponse> {
    const headers = this.getAuthHeaders();

    console.log('📥 Chargement tâches:', { propertyId, page, size });

    return this.http.get<TasksResponse>(
      `${this.apiUrl}/tasks/by-property/${propertyId}?page=${page}&size=${size}`,
      { headers }
    ).pipe(
      catchError((error) => {
        console.error('❌ Erreur chargement tâches:', error);

        return throwError(() => ({
          status: error.status,
          message: error.error?.message || error.message || 'Erreur lors du chargement des tâches',
          error: error
        }));
      })
    );
  }

  putBudget(id: number, amont: number): Observable<any> {
    const headers = this.getAuthHeaders();
    const params = new HttpParams().set('amont', amont.toString());

    return this.http.put<any>(
      `${this.apiUrl}/budgets/${id}`,
      null,
      { headers, params }
    ).pipe(catchError(this.handleError));
  }

  getDepense(budgetId: number, page: number = 0, size: number = 10): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get<any>(`${this.apiUrl}/expenses/budget/${budgetId}?page=${page}&size=${size}`, { headers })
      .pipe(catchError(this.handleError));
  }


  /**
  * Créer une nouvelle dépense avec upload de fichier
  */
  createDepense(expenseData: CreateExpenseRequest): Observable<ExpenseResponse> {
    const formData = new FormData();

    // Ajouter les champs texte
    formData.append('date', expenseData.date);

    if (expenseData.description) {
      formData.append('description', expenseData.description);
    }

    if (expenseData.amount !== undefined && expenseData.amount !== null) {
      formData.append('amount', expenseData.amount.toString());
    }

    if (expenseData.budgetId !== undefined && expenseData.budgetId !== null) {
      formData.append('budgetId', expenseData.budgetId.toString());
    }

    // Ajouter le fichier s'il existe
    if (expenseData.evidence) {
      formData.append('evidence', expenseData.evidence, expenseData.evidence.name);
    }

    return this.http.post<ExpenseResponse>(
      `${this.apiUrl}/expenses`,
      formData
    );
  }


  putDepense(id: number, expense: any): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.put<any>(`${this.apiUrl}/expenses/${id}`, expense, { headers })
      .pipe(catchError(this.handleError));
  }


  deleteDepense(id: number): Observable<void> {
    const headers = this.getAuthHeaders();
    return this.http.delete<void>(`${this.apiUrl}/expenses/${id}`, { headers })
      .pipe(catchError(this.handleError));
  }
  // 5. ✅ CORRECTION: deleteTask - Meilleure gestion des erreurs
  deleteTask(id: number): Observable<void> {
    const headers = this.getAuthHeaders();

    console.log('🗑️ Suppression tâche:', id);

    return this.http.delete<void>(
      `${this.apiUrl}/tasks/${id}`,
      { headers }
    ).pipe(
      catchError((error) => {
        console.error('❌ Erreur suppression tâche:', error);

        return throwError(() => ({
          status: error.status,
          message: error.error?.message || error.message || 'Erreur lors de la suppression de la tâche',
          error: error
        }));
      })
    );
  }

  deleteAlbum(id: number): Observable<void> {
    const headers = this.getAuthHeaders();
    return this.http.delete<void>(`${this.apiUrl}/progress-album/delete/${id}`, { headers })
      .pipe(catchError(this.handleError));
  }

  getDocumentsType(): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get<any>(`${this.apiUrl}/documents/types`, { headers })
      .pipe(catchError(this.handleError));
  }

  updateIndicator(indicatorId: number, progressPercentage: number): Observable<any> {
    const headers = this.getAuthHeaders();
    const params = new HttpParams().set('progressPercentage', progressPercentage.toString());

    return this.http.put<any>(
      `${this.apiUrl}/indicators/update/${indicatorId}`,
      null,
      { headers, params }
    ).pipe(catchError(this.handleError));
  }

  getDocuments(propertyId: number, page: number = 0, size: number = 10): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get<any>(`${this.apiUrl}/documents/property/${propertyId}?page=${page}&size=${size}`, { headers })
      .pipe(catchError(this.handleError));
  }

  saveDocument(formData: FormData): Observable<any> {
    const headers = this.getAuthHeaders(true);

    // Ajouter les champs requis même s'ils sont vides
    const requiredFields = ['title', 'description', 'realEstatePropertyId', 'typeId', 'startDate', 'endDate'];
    requiredFields.forEach(field => {
      if (!formData.has(field)) {
        formData.append(field, '');
      }
    });

    if (!formData.has('file')) {
      formData.append('file', '');
    }

    // Log des clés et valeurs du FormData avec assertion de type
    console.log('Envoi FormData pour document avec champs:');
    for (const [key, value] of (formData as any).entries()) {
      console.log(`${key}: ${value instanceof File ? value.name : value}`);
    }

    // Vérifier le token
    const token = headers.get('Authorization')?.replace('Bearer ', '');
    console.log('Token envoyé:', token ? token.substring(0, 20) + '...' : 'Aucun token');

    return this.http.post<any>(`${this.apiUrl}/documents/add`, formData, { headers })
      .pipe(
        catchError((error) => {
          console.error('Erreur détaillée lors de la création du document:', error);
          return this.handleError(error);
        })
      );
  }
  deleteDocument(id: number): Observable<void> {
    const headers = this.getAuthHeaders();
    return this.http.delete<void>(`${this.apiUrl}/documents/${id}`, { headers })
      .pipe(catchError(this.handleError));
  }


  getSignalement(propertyId: number, page: number = 0, size: number = 10): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get<any>(`${this.apiUrl}/incidents?propertyId=${propertyId}&page=${page}&size=${size}`, { headers })
      .pipe(catchError(this.handleError));
  }
  // Dans project-budget.service.ts
  saveSignalementWithFormData(formData: FormData): Observable<any> {
    const headers = this.getAuthHeaders(true);
    return this.http.post<any>(`${this.apiUrl}/incidents/save`, formData, { headers })
      .pipe(catchError(this.handleError));
  }
  saveSignalement(data: CreateSignalementRequest | FormData): Observable<any> {
    let headers: HttpHeaders;

    if (data instanceof FormData) {
      headers = this.getAuthHeaders(true); // Headers pour FormData
    } else {
      headers = this.getAuthHeaders(); // Headers pour JSON
    }

    return this.http.post<any>(`${this.apiUrl}/incidents/save`, data, { headers })
      .pipe(catchError(this.handleError));
  }

  changeStatusIncident(incidentId: number, status: string): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.patch<any>(`${this.apiUrl}/incidents/${incidentId}/status`, { status }, { headers })
      .pipe(catchError(this.handleError));
  }

  deleteSignalement(id: number): Observable<void> {
    const headers = this.getAuthHeaders();
    return this.http.delete<void>(`${this.apiUrl}/incidents/${id}`, { headers })
      .pipe(catchError(this.handleError));
  }

  // Méthode utilitaire pour debug
  checkAuthToken(): void {
    const possibleKeys = ['token', 'authToken', 'accessToken', 'jwt', 'bearerToken'];

    console.log('=== VÉRIFICATION DES TOKENS ===');
    possibleKeys.forEach(key => {
      const localValue = localStorage.getItem(key);
      const sessionValue = sessionStorage.getItem(key);

      if (localValue) {
        console.log(`localStorage.${key}:`, localValue.substring(0, 20) + '...');
      }
      if (sessionValue) {
        console.log(`sessionStorage.${key}:`, sessionValue.substring(0, 20) + '...');
      }
    });

    console.log('Clés localStorage:', Object.keys(localStorage));
    console.log('Clés sessionStorage:', Object.keys(sessionStorage));
    console.log('===============================');
  }
}